export const DIVIDER_LABEL = 'млн';

export const MPK_ROLE_ID = {
  ADMIN: 1,
  HEAD_MPK: 2,
  SECRETARY_MPK: 3,
  SECRETARY_FOIV: 7,
  CURATOR_FOIV: 8,
  CURATOR_MPK: 35,
};

export const ORDER_MONITORING_STATUS = {
  ALL: 'Все',
  COMPLETED: 'Выполнено',
  WORK: 'В работе',
  OVERDUE: 'Просрочено',
  NOT_COMPLETED: 'Не выполнено',
  IN_PROCESS: 'В процессе',
};

export const ORDER_MONITORING_STATUS_ID = {
  IN_WORK: 1,
  DONE: 2,
  NOT_DONE: 3,
  OVERDUE: 4,
};

export const MPK_ASSIGNMENT_STATUS = {
  NEW: 1, // новый
  IN_WORK: 2, // В работе
  APPROVAL_HEAD_FOIV: 3, // Согласовано сотрудником ФОИВ
  APPROVAL_SECRETARY_MPK: 4, // Согласовано сотрудником МПК
  COMPLETED: 5, // Выполнено
  NOT_COMPLETED: 6, // Не выполнено
  NOT_COMPLETED_FOREIGN: 7, // Не выполнено по причине иностранной стороны
  NOT_DONE_NOT_ACTUAL: 8, // Не выполнено в связи с потерей актуальности
  APPROVAL_SECRETARY_EXECUTOR: 9, // На согласовании секретаря исполнителя
  APPROVAL_HEAD_EXECUTOR: 10, // На согласовании руководителя исполнителя
};

export const ID_TYPE_BUSINESS_ADVICE = 8;
export const ID_TYPE_BUSINESS_ADVICE_RF = 7;

export const EVENT_TYPE_CATEGORY_ID = {
  MPK_SC_RG: 1,
  BUSINESS_ADVICE: 2,
};

export const ASSIGNMENT_OBJECT_TYPE_EVENT = 0;

export const SET_LIMIT_MOD = {
  ALL: 'all',
  ADD: 'add',
};

export const DiffPlace = {
  BALANCE_PLACE: 'diffPlaceInRussianBalance',
  EXPORT_NON_ENERGY_PLACE: 'diffPlaceInRussianExportNonEnergy',
  EXPORT_PLACE: 'diffPlaceInRussianExports',
  IMPORT_PLACE: 'diffPlaceInRussianImports',
  TRADE_TURNOVER_PLACE: 'diffPlaceInRussianTradeTurnover',
};

export const DUE_DATE_FOR_PERMANENT = 'Выполняется на постоянной основе';

export const COMMISSION_TYPE_MAP = {
  mp: 'mp',
  sc: 'sc',
  rg: 'rg',
};

export const COMMISSION_TYPE_IDS = {
  1: COMMISSION_TYPE_MAP.mp,
  2: COMMISSION_TYPE_MAP.sc,
  3: COMMISSION_TYPE_MAP.rg,
};

export const COMMISSION_TYPE_IDS_REVERSE = {
  [COMMISSION_TYPE_MAP.mp]: 1,
  [COMMISSION_TYPE_MAP.sc]: 2,
  [COMMISSION_TYPE_MAP.rg]: 3,
};

export const ACCEPT_FILE_EXTENSIONS = ['doc', 'docx', 'xlsx', 'xls', 'pptx', 'pdf', 'jpg', 'jpeg', 'png', 'svg'];

export const STATUS_ID = {
  ACTIVE: 1,
  FROZEN: 2,
};
export const STATUS_LABEL_BY_ID = {
  [STATUS_ID.ACTIVE]: 'Действующая',
  [STATUS_ID.FROZEN]: 'Заморожена',
};

export const MPK_STRUCTURE_TREE_PARENT_EXTEND_PX = {
  WITH_SUBCOMMISSIONS: 220,
  WITH_SUBCOMMISSIONS_AND_CHILD_WORK_ORGANS: 320,
  WITHOUT_SUBCOMMISSIONS: 41,
};
